module.exports = __webpack_public_path__ + "img/esquemaI.36a72eda.svg";